import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClock } from '@fortawesome/free-solid-svg-icons';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FaCalendar } from 'react-icons/fa';
import { FaClock } from 'react-icons/fa';
import Calendar_Icon from "../images/Calendor_Icon.svg"
import { FaSort, FaSortUp, FaSortDown } from "react-icons/fa";
import Select from "react-select";

library.add(faClock);
export const getNewListWithModifyChecked = (index, arr) => {
  // Your initial array
  // Check if the index is valid
  if (index >= 0 && index < arr.length) {
    // Modify the 'checked' value at the specified index
    arr[index].checked = !arr[index].checked;

  }
  // Return the modified array
  return arr;
}
export const extractTimeFromDate = (dateTimeString) => {
  const dateObject = new Date(dateTimeString);
  const options = {
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
  };
  const timeOnly = dateObject.toLocaleTimeString('en-US', options);
  return timeOnly;
};


export const TimeInput = ({ value, onClick, openDatePicker }) => {
  const handleTimeIconClick = () => {
    alert("clickDate")
    openDatePicker();
  };
  return (
    <div className="input-group" >
      <input
        type="text"
        className="form-control"
        value={value}
        onClick={onClick}
        readOnly />

      <div className="input-group-append" onClick={handleTimeIconClick}>
        <span className="input-group-text">
          <FontAwesomeIcon icon="clock" />
        </span>
      </div>
    </div>
  );
}

export const CustomDatePickerInputforReviewwdwork = ({ value, onClick }) => (
  <div style={{ position: "relative" }}>
    <input
      className="form-control col-12"
      type="text"
      value={value}
      onClick={onClick}
      readOnly
      style={{
        cursor: "pointer",
        padding: "5px 10px",
        background: "white",
        width: "140px",
      }}
    />
    <img
      src={Calendar_Icon}
      alt="Calendar"
      onClick={onClick}
      style={{
        position: "absolute",
        cursor: "pointer",
        right: "5px", // Move icon left
        top: "10px",
        width: "18px",
        height: "18px",
      }}
    />
  </div>
);

export const CustomDatePickerInput = ({ value, onClick, placeholder }) => (
  <div style={{ position: "relative" }}>
    <input
      className="form-control col-12 custom-date-input"
      type="text"
      // value={value}
      value={value || ""}
      onClick={onClick}
      placeholder={placeholder}
      readOnly
      style={{
        cursor: "pointer", padding: "5px 35px 5px 10px", background: "white", height: "43px",
      }}
    />

    <img
      src={Calendar_Icon}
      alt="Calendar"
      onClick={onClick}
      style={{
        position: "absolute",
        cursor: "pointer",
        right: "13px",
        top: "50%",
        transform: "translateY(-50%)",
        width: "18px",
        height: "18px",
      }}
    />
  </div>
);

export const CustomTimePickerInput = ({ value, onClick, placeholder }) => (
  <div style={{ position: "relative" }}>
    <input
      className="form-control w-full custom-time-input"
      type="text"
      value={value}
      onClick={onClick}
      placeholder={placeholder}
      readOnly
      style={{
        cursor: "pointer",
        padding: "5px 35px 5px 10px",
        background: "white",
      }}
    />

    <FaClock
      onClick={onClick}
      style={{
        position: "absolute",
        cursor: "pointer",
        right: "13px",
        top: "50%",
        transform: "translateY(-50%)",
        color: "#4A7729", // #4A7729 icon
        fontSize: "16px",
      }}
    />
  </div>
);

export const CustomTimePickerInputforFireWatch = ({ value, onClick }) => (
  <div>
    <input className='form-control w-full'
      type="text"
      value={value}
      onClick={onClick}
      readOnly
      style={{ cursor: 'pointer', padding: '5px 10px', background: 'white', width: "140px" }}
    />
    <FaClock style={{ position: "absolute", cursor: "pointer", right: "13px", top: "10px " }}
      onClick={onClick} />
  </div>
);


export const gridSorting = (items, sortConfig) => {
  return [...items].sort((a, b) => {
    if (sortConfig.key) {
      const aValue = a[sortConfig.key];
      const bValue = b[sortConfig.key];

      // Check if values are numeric
      if (!isNaN(aValue) && !isNaN(bValue)) {
        return sortConfig.direction === "asc" ? aValue - bValue : bValue - aValue;
      }

      // Fallback for string comparison
      const aString = aValue?.toString().toLowerCase();
      const bString = bValue?.toString().toLowerCase();
      if (aString < bString) return sortConfig.direction === "asc" ? -1 : 1;
      if (aString > bString) return sortConfig.direction === "asc" ? 1 : -1;
      return 0;
    }
    return 0;
  });
};


export const customStyles = {
  control: (provided) => ({
    ...provided,
    width: '250px',
    minWidth: '250px',
    maxWidth: '250px',
    borderColor: '#4A7729',
    boxShadow: 'none',
    '&:hover': {
      borderColor: '#4A7729',
    },
  }),

  dropdownIndicator: (provided) => ({
    ...provided,
    color: '#4A7729',
    '&:hover': {
      color: '#4A7729',
    },
  }),

  indicatorSeparator: () => ({
    display: 'none',
  }),

  valueContainer: (provided) => ({
    ...provided,
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
  }),

  singleValue: (provided) => ({
    ...provided,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    color: '#000',
  }),

  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected
      ? '#4A7729'
      : state.isFocused
        ? '#d3ebc1'
        : '#fff',
    color: state.isSelected ? '#fff' : '#000',
    cursor: 'pointer',
    fontWeight: 400, // Options remain normal
    '&:active': {
      backgroundColor: '#4A7729',
    },
  }),

  // Add this section only
  groupHeading: (provided) => ({
    ...provided,
    fontWeight: 'bold',
    color: '#000',
    fontSize: '16px',
    textTransform: 'none',
    paddingTop: '6px',
    paddingBottom: '6px',
  }),
};



export const customstyles = {
  control: (provided, state) => ({
    ...provided,
    borderColor: '#4A7729',
    boxShadow: 'none',
    outline: 'none',
    minHeight: "36px",
    height: "36px",
    width: "80px",

    '&:hover': {
      borderColor: '#4A7729',
    },

    ...(state.isFocused && {
      borderColor: '#4A7729',
      boxShadow: 'none',
    }),
  }),

  dropdownIndicator: (provided) => ({
    ...provided,
    color: '#4A7729',

    '&:hover': {
      color: '#4A7729',
    },
  }),

  // Optional: Hide the vertical separator line
  indicatorSeparator: (provided) => ({
    ...provided,
    backgroundColor: '#4A7729',
    // Or use: display: 'none',
  }),

  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected
      ? '#4A7729'
      : state.isFocused
        ? '#d3ebc1'
        : '#fff',
    color: state.isSelected ? '#fff' : '#000',
    cursor: 'pointer',

    '&:active': {
      backgroundColor: '#4A7729',
    },
  }),
};

export const modalCustomStyles = {
  control: (provided, state) => ({
    ...provided,
    minHeight: "44px",
    height: "44px",
    borderColor: state.isFocused ? "#C9E4B4" : provided.borderColor,
    boxShadow: state.isFocused ? "#C9E4B4" : "none",
    "&:hover": {
      borderColor: "#C9E4B4",
    },
  }),

  valueContainer: (provided) => ({
    ...provided,
    height: "44px",
    padding: "0 8px",
  }),

  input: (provided) => ({
    ...provided,
    margin: "0",
    padding: "0",
  }),

  indicatorsContainer: (provided) => ({
    ...provided,
    height: "44px",
  }),

  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected
      ? "#4A7729"
      : state.isFocused
        ? "#d3ebc1"
        : "#fff",
    color: state.isSelected ? "#fff" : "#000",
    cursor: "pointer",
    "&:active": {
      backgroundColor: "#4A7729",
    },
  }),

  dropdownIndicator: (provided) => ({
    ...provided,
    color: "#4A7729",
    "&:hover": {
      color: "#4A7729",
    },
  }),

  singleValue: (provided) => ({
    ...provided,
    color: "#212529",
  }),
};
export const customStylesPeoplesection = {
  control: (provided, state) => ({
    ...provided,
    width: "250px",
    minWidth: "250px",
    maxWidth: "250px",
    borderColor: "#4A7729",
    boxShadow: state.isFocused ? "0 0 0 1px #4A7729" : "none",
    "&:hover": {
      borderColor: "#4A7729",
    },
  }),

  menu: (provided) => ({
    ...provided,
    zIndex: 9999,
  }),

  menuPortal: (provided) => ({
    ...provided,
    zIndex: 9999,
  }),

  dropdownIndicator: (provided, state) => ({
    ...provided,
    color: "#4A7729",
    "&:hover": {
      color: "#4A7729",
    },
  }),

  indicatorSeparator: () => ({
    display: "none",
  }),

  valueContainer: (provided) => ({
    ...provided,
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
  }),

  // singleValue: (provided) => ({
  //   ...provided,
  //   overflow: "hidden",
  //   textOverflow: "ellipsis",
  //   whiteSpace: "nowrap",
  //   color: "#4A7729",
  //   fontWeight: 600,
  // }),
  singleValue: (provided) => ({
    ...provided,
    color: "#000",
    fontWeight: 400,
  }),

  placeholder: (provided) => ({
    ...provided,
    color: "#6c757d",
  }),

  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected
      ? "#4A7729"
      : state.isFocused
        ? "#d3ebc1"
        : "#fff",
    color: state.isSelected ? "#fff" : "#000",
    cursor: "pointer",
    fontWeight: state.isSelected ? 600 : 400,
    "&:active": {
      backgroundColor: "#4A7729",
    },
  }),

  groupHeading: (provided) => ({
    ...provided,
    fontWeight: "bold",
    color: "#000",
    fontSize: "16px",
    textTransform: "none",
    paddingTop: "6px",
    paddingBottom: "6px",
  }),
};

export const formatRoleName = (value) => {
  return value
    .replace(/[^a-zA-Z\s]/g, "")
    .replace(/\b[a-z]/g, (char) => char.toUpperCase());
};
